import FinalFormField from 'common/components/final-form/FinalFormField';
import FinalFormYesNo from 'common/components/final-form/FinalFormYesNo';
import ChsAddress from 'domain/types/ChsAddress';
import { validateAddress } from 'domain/utils';
import { FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { StreetTypes } from './StreetTypes';
import { UnitTypes } from './UnitTypes';

interface IAddressFormNew {
  data: ChsAddress | null;
  onChange: (data: ChsAddress) => void;
  validate?: boolean;
}

const Fields = ({ values, prefix }: { values: ChsAddress; prefix: string }) => (
  <>
    <Row>
      <FinalFormField
        name={`${prefix}houseNumber`}
        label='House Number: *'
        className='col-sm-12 col-md-6 col-lg-3'
        onKeyDown={(e) => /^[0-9\/ ]$/.test(e)}
      />
      <FinalFormField
        name={`${prefix}streetDir`}
        label='Street Direction: *'
        type='select'
        className='col-sm-12 col-md-6 col-lg-3'
        options={[
          { cd: '', descr: '--' },
          { cd: 'N', descr: 'North' },
          { cd: 'S', descr: 'South' },
          { cd: 'E', descr: 'East' },
          { cd: 'W', descr: 'West' },
        ]}
      />
      <FinalFormField
        name={`${prefix}streetName`}
        label='Street Name: *'
        className='col-sm-12 col-md-6 col-lg-4'
      />
      <FinalFormField
        name={`${prefix}streetType`}
        label='Street Type:'
        className='col-sm-12 col-md-6 col-lg-2'
        type='select'
        options={StreetTypes}
      />
    </Row>
    <Row>
      <FinalFormYesNo
        name={`${prefix}singleFamilyHome`}
        className='col-12'
        label='Single Family Home / Townhome'
        info='Only applicable to single family homes or townhouses that do not have unit numbers.'
      />
      <FinalFormField
        name={`${prefix}unitType`}
        label='Unit Type:'
        type='select'
        className='col-sm-3'
        disabled={values?.singleFamilyHome === 'Y'}
        when={{
          field: `${prefix}singleFamilyHome`,
          becomes: 'Y',
          set: `${prefix}unitType`,
          to: '',
        }}
        options={UnitTypes}
      />

      <FinalFormField
        name={`${prefix}unitNumber`}
        label='Unit Number:'
        className='col-sm-3'
        disabled={values?.singleFamilyHome === 'Y'}
        when={{
          field: `${prefix}singleFamilyHome`,
          becomes: 'Y',
          set: `${prefix}unitNumber`,
          to: '',
        }}
      />
    </Row>
    <Row>
      <FormGroup className='col-sm-4'>
        <FormLabel>City: *</FormLabel>
        <FormControl disabled value={'Chicago'} />
      </FormGroup>
      <FormGroup className='col-sm-4'>
        <FormLabel>State: *</FormLabel>
        <FormControl disabled value={'IL'} />
      </FormGroup>
      <FinalFormField
        name={`${prefix}zipCode`}
        label='Zip Code: *'
        className='col-sm-4'
      />
    </Row>
  </>
);

const AddressForm = (props: IAddressFormNew) => {
  return (
    <Form<ChsAddress>
      onSubmit={props.onChange}
      initialValues={{ ...props.data }}
      validate={props.validate ? validateAddress : undefined}
    >
      {({ handleSubmit, values }) => (
        <form
          id='addressForm'
          onSubmit={handleSubmit}
          onChange={() => {
            /* 
            This is smelly and I hate it :^)
            We force a submit here everytime the state changes, to update the parent state.
            This is kind of backwards and very anti-pattern, but it works.
            Adding handleSubmit to onChange does not fire the submit event correctly. The form state is correctly
            updated, but the form is visually not re-rendered until focus is lost. 
            */
            document
              .getElementById('addressForm')
              ?.dispatchEvent(
                new Event('submit', { cancelable: true, bubbles: true })
              );
          }}
        >
          <Fields values={values} prefix='' />
        </form>
      )}
    </Form>
  );
};

export { Fields };

export default AddressForm;
